import { Component, Input, OnInit } from '@angular/core';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { DOWNLOAD_TYPES } from 'src/app/constants/products/product-download-settings';
import { PaginationInput, PaginationPageEvent, ListParams, Res, DownloadTypes } from 'src/app/models';
import { DialogModalService, FilesService } from 'src/app/services';
import { ProductsDataDownloadService } from 'src/app/services/products-data-download.service';

@Component({
  selector: 'app-products-download-history',
  templateUrl: './products-download-history.component.html',
  styleUrls: ['./products-download-history.component.css']
})
export class ProductsDownloadHistoryComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  progressRef: NgProgressRef;
  currentOrgData: any;
  loading: boolean;
  orgHistory: any[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  download_types: DownloadTypes[] = DOWNLOAD_TYPES;
  

  @Input() set objectData(value) {

    if (value != null) {

      this.currentOrgData = value.org_id;

      this.getList(this.currentOrgData);
    }
  }

  constructor(
    public ngProgress: NgProgress,
    private fileService: FilesService,
    private downloadProductService: ProductsDataDownloadService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.subscriptions.add(
      this.downloadProductService.listenerProductDataForReload().subscribe(val => {

        if(val){

          this.getList(val);
        }
        
      })
    );
  }

  /**
   * 
   * @param org_id 
   */
  getList(org_id: string = '') {


    this.fileService.getDownloadHistoryByOrg(org_id).subscribe((response: Res) => {
      console.log('[RESPONSE] fileHistory: ', response);

      if (response != null) {

        this.orgHistory = response.result;

      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });

  }

  /**
   * 
   * @param type 
   * @returns 
   */
  changeName(type:string){

    return this.download_types.find(val=> val.type == type).name;
  }


  /**
   * 
   * @param item 
   */
  onDownload(item:any) {

    this.fileService.downloadWithSettings('downloadWithSettings', item);

  }

  /**
   * 
   * @param item 
   */
  onEditDownload(item:any){

    this.downloadProductService.setProductData(item);
    this.downloadProductService.switchTab(true);

  }

}
